import { render, staticRenderFns } from "./title_suggestions.vue?vue&type=template&id=101e38bc"
import script from "./title_suggestions.vue?vue&type=script&lang=js"
export * from "./title_suggestions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports